import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { RecordingJob } from "app/js/src/domain/recording-job";
import { RecordingSource } from "app/js/src/domain/recording-source";
import { RecordingStatus } from "app/js/src/domain/recording";
import { RecordingService } from "app/js/src/services/recording/recording.service";
import { LiveFeedRepository } from "app/js/src/domain/live-feed-repository";
import { StreamingPlatform } from "app/js/src/domain/live-feed";
import { Router } from "@angular/router";

@Component({
  selector: "evrideo-recording-job-sources",
  templateUrl: "./recording-job-sources.component.html",
  styleUrls: ["./recording-job-sources.component.scss"],
})
export class RecordingJobSourcesComponent implements ICellRendererAngularComp {
  recordingJob: RecordingJob;
  params: any;
  platformNamesById: Map<number, string> | null = null;
  constructor(
    private recordingService: RecordingService,
    private liveFeedRepository: LiveFeedRepository,
    private router: Router,
  ) {}

  agInit(params: any): void {
    this.params = params;
    this.recordingJob = params.node.data;
    const hasPlatformSource = this.recordingJob.recordingSources.some(
      (source) => source.streamingPlatformId != null,
    );
    if (hasPlatformSource) {
      const context = params.context;
      if (!context.streamingPlatformsPromise) {
        context.streamingPlatformsPromise =
          this.liveFeedRepository.getAllStreamingPlatforms();
      }
      context.streamingPlatformsPromise.then(
        (platforms: StreamingPlatform[]) => {
          this.platformNamesById = new Map(
            platforms.map((p) => [p.id, p.availabilityZoneName]),
          );
        },
      );
    }
  }

  getPlatformName(source: RecordingSource): string | null {
    if (source.streamingPlatformId == null || !this.platformNamesById) {
      return null;
    }
    return this.platformNamesById.get(source.streamingPlatformId) || null;
  }

  resourceFailed(source: RecordingSource) {
    const record = this.recordingJob.recordings.find(
      (x) => x.sourceId === source.id,
    );
    return record && record.status === RecordingStatus.Error;
  }

  goToMedia(sourceId: string): void {
    this.recordingService
      .GetRecordingSourceMediaId(sourceId, this.recordingJob.id)
      .then((mediaId) => {
        if (mediaId) {
          this.router.navigate(["/mam/editMedia", mediaId], {
            queryParamsHandling: "preserve",
          });
        }
      });
  }
  refresh(params: any): boolean {
    return false;
  }
}
